
import { createStore, compose, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

// import logger from 'redux-logger';
// import { persistStore } from 'redux-persist';
import reducers from './reducers';
import monitorReducersEnhancer from './enhancers/monitorReducers'

// const quoteStore = createStore(reducers, (process.env.NODE_ENV !== 'production' ? applyMiddleware(logger) : ['']));

// const persistor = persistStore(quoteStore);

// export { quoteStore, persistor };


import loggerMiddleware from './middlewares/logger'
// import rootReducer from './reducers'

export default function configureStore(preloadedState) {

    const middlewares = [loggerMiddleware]
    const middlewareEnhancer = applyMiddleware(...middlewares)

    const enhancers = [middlewareEnhancer, monitorReducersEnhancer]
    const composedEnhancers = composeWithDevTools(...enhancers)

    const ndel_store = createStore(reducers, preloadedState, composedEnhancers)

    return ndel_store
}

// const persistor = persistStore(configureStore());
// export { persistor };